import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";
import { Container } from "react-bootstrap";
import Button from "shared/components/inputs/mui/Button";
import Text from "shared/components/data-display/mui/Text";
import Link from "shared/components/navigation/links/Link";
import Alert from "shared/components/utils/icons/Alert";
import { useStylesForText } from "shared/styles/makeStyles";
import { useStyles, Action, Content, QuestionWrapper } from "./Confirmation.styles";

const ConfirmationModal = (props) => {
    const { title, question, onConfirm, onCancel, buttonLabel, onHide } = props;
    const classesText = useStylesForText();
    const classes = useStyles();
    const handleClose = () => {
        ReactDOM.render(null, document.getElementById("divPageModal"));
    };

    return (
        <>
            <Modal.Header
                className={classes.title}
                onHide={(e) => {
                    if (onHide) onHide(e);
                }}
            >
                <Modal.Title>
                    <Alert size="24" />
                    <Text variant="xlarge"> {title}</Text>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container fluid>
                    <Content>
                        {props.children && (
                            <Text
                                variant="medium"
                                className={classesText.gray2}
                            >
                                {props.children}
                            </Text>
                        )}
                        {question && (
                            <QuestionWrapper>
                                <Text
                                    variant="medium"
                                    className={classesText.gray2}
                                >
                                    {question}
                                </Text>
                            </QuestionWrapper>
                        )}
                    </Content>
                </Container>
            </Modal.Body>
            <Action>
                <Link
                    variant="secondary"
                    onClick={(e) => {
                        if (onCancel) {
                            onCancel(e);
                        }
                        handleClose();
                    }}
                >
                    Cancel
                </Link>
                <Button
                    onClick={(e) => {
                        if (onConfirm) {
                            onConfirm(e);
                        }
                        handleClose();
                    }}
                >
                    {buttonLabel}
                </Button>
            </Action>
        </>
    );
};

ConfirmationModal.defaultProps = {
    question: "Do you wish to continue?",
};

ConfirmationModal.propTypes = {
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func,
    question: PropTypes.string,
    buttonLabel: PropTypes.string,
    title: PropTypes.string,
    children: PropTypes.node,
    onHide: PropTypes.func,
};

export default ConfirmationModal;
